import { CoverageId, InsuranceCoverage, PopulatedAssessment } from '../../types'
import { FieldMap, Form } from '../../types/forms'
import {
  capitalizeFirstLetter,
  getHasPrimaryCoverage,
  getHasSecondaryCoverage,
  getPrimaryIsMedicaid,
  getSecondaryIsMedicaid,
} from '../../utils'
import callDetails from './callDetails'
import callInDirections from './callInDirections'
import inNetwork from './inNetwork'
// import maximumReimbursableCharges from './maximumReimbursableCharges'
import outOfNetwork from './outOfNetwork'
import planCoversMidwives from './planCoversMidwives'
import { planDesignAndStateMandatesField } from './planDesignAndStateMandates'
// import reimbursementOption from './reimbursementOption'
export const callIn: Form = {
  name: 'Call-In Questions for your Insurer',
  path: 'insuranceInfo.primaryCoverage',
  pathName: 'Primary Coverage',
  description:
    "We'll guide you though a call with your insurance provider to get more information on your coverage",
  stages: {
    directions: callInDirections,
    'in-network': inNetwork,
    'out-of-network': outOfNetwork,
    // these two were moved to out of network
    // 'reimbursement-option': reimbursementOption,
    // 'maximum-reimbursable-charges': maximumReimbursableCharges,
    'plan-covers-midwives': planCoversMidwives,
    'plan-design-and-state-mandates': planDesignAndStateMandatesField,
    'call-details': callDetails,
  },
}

export const callInField: FieldMap = {
  name: 'Call In Questions',
  children: callIn.stages,
}

export const getCallInForm = (
  admin: boolean,
  assessment?: Omit<PopulatedAssessment, 'availableForms' | 'stages' | 'plans'> | null,
): Form | null => {
  const returnForm = (coverageId: CoverageId, coverage: InsuranceCoverage) => ({
    ...callIn,
    name: `Call-In Questions for ${coverage?.insuranceProvider?.name} - ${coverage?.memberId ? `Member ID: ${coverage.memberId}` : 'No Member ID'}`,
    path: `insuranceInfo.${coverageId}Coverage`,
    pathName: `${capitalizeFirstLetter(coverageId)} Coverage`,
  })

  const insuranceInfo = admin
    ? assessment?.mergedData?.insuranceInfo
    : assessment?.data?.insuranceInfo

  const hasPrimaryCoverage = getHasPrimaryCoverage(insuranceInfo ?? {})
  if (!hasPrimaryCoverage) return null
  const primaryIsMedicaid = getPrimaryIsMedicaid(insuranceInfo ?? {})
  if (!primaryIsMedicaid) return returnForm('primary', insuranceInfo?.primaryCoverage)
  const hasSecondaryCoverage = getHasSecondaryCoverage(insuranceInfo ?? {})
  if (!hasSecondaryCoverage) return null
  const secondaryIsMedicaid = getSecondaryIsMedicaid(insuranceInfo ?? {})
  if (!secondaryIsMedicaid) return returnForm('secondary', insuranceInfo?.secondaryCoverage)
  return null
}
